import React from "react";
import Map from "./map";
export default function App() {
  return <Map />;
}
